import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const prefix = '/'

const routes = [
	
	{
		path: prefix
		,name: 'intro'
		,component: () => import('@/view/Auth/Login.vue')
	}
	,{
		path: prefix + 'Index'
		,name: 'Index'
		,component: () => import('@/view/Main/Index.vue')
	}
	,{
		path: prefix + 'Auth/Guid/:type'
		,name: 'Auth'
		,component: () => import('@/view/Auth/Terms.vue')
	}
	,{
		path: prefix + 'Auth/Login/:idx?/:link?'
		,name: 'Login'
		,component: () => import('@/view/Auth/Login.vue')
	}
	,{
		path: prefix + 'Auth/Find/Id'
		,name: 'FindId'
		,component: () => import('@/view/Auth/FindId.vue')
	}
	,{
		path: prefix + 'Auth/Find/Pw'
		,name: 'FindPw'
		,component: () => import('@/view/Auth/FindPw.vue')
	}
	,{
		path: prefix + 'Auth/Join/:code?'
		,name: 'Join'
		,component: () => import('@/view/Auth/Join.vue')
	}
	,{
		path: prefix + 'Auth/Result'
		,name: 'JoinResult'
		,component: () => import('@/view/Auth/Result.vue')
	}
	,{
		path: prefix + 'Account/MyPage'
		,name: 'MyPage'
		,component: () => import('@/view/Account/MyPage.vue')
	}
	,{
		path: prefix + 'Account/Modify'
		,name: 'Modify'
		,component: () => import('@/view/Account/Modify.vue')
	}
	,{
		path: prefix + 'Account/Password'
		,name: 'Password'
		,component: () => import('@/view/Account/Password.vue')
	}
	,{
		path: prefix + 'Account/Otp'
		,name: 'Otp'
		,component: () => import('@/view/Account/Otp.vue')
	}
	,{
		path: prefix + 'Account/PhoneNumber'
		,name: 'PhoneNumber'
		,component: () => import('@/view/Account/PhoneNumber.vue')
	}
	,{
		path: prefix + 'Account/Point/List'
		,name: 'PointList'
		,component: () => import('@/view/Account/PointList')
	}
	,{
		path: prefix + 'Account/Point/History'
		,name: 'PointHistory'
		,component: () => import('@/view/Account/PointHistory')
	}
	,{
		path: prefix + 'Account/Point/Present'
		,name: 'PointPresent'
		,component: () => import('@/view/Account/PointPresent')
	}
	,{
		path: prefix + 'Account/Qan'
		,name: 'Qna'
		,component: () => import('@/view/Account/Qna')
	}
	,{
		path: prefix + 'CustomerCenter/:b_code'
		,name: 'CustomerCenter'
		,component: () => import('@/view/Customer/CustomerCenter.vue')
	}
	,{
		path: prefix + 'Bbs/Item/:b_code'
		,name: 'BbsItem'
		,component: () => import('@/view/Bbs/BbsItem.vue')
	}
	,{
		path: prefix + 'Bbs/Detail/:b_code/:bbs_id'
		,name: 'BbsDetail'
		,component: () => import('@/view/Bbs/BbsDetail')
	}
	,{
		path: prefix + 'Project/List'
		,name: 'ProjectList'
		,component: () => import('@/view/Project/ProjectList')
	}
	,{
		path: prefix + 'Project/Item'
		,name: 'ProjectItem'
		,component: () => import('@/view/Project/ProjectItem')
	}
	,{
		path: prefix + 'Project/View/:idx'
		,name: 'ProjectView'
		,component: () => import('@/view/Project/ProjectView')
	}
	,{
		path: prefix + 'Project/Detail/:idx'
		,name: 'ProjectDetail'
		,component: () => import('@/view/Project/ProjectDetail')
	}
	,{
		path: prefix + 'Project/Work/:idx'
		,name: 'ProjectWork'
		,component: () => import('@/view/Project/ProjectWork')
	}
	,{
		path: prefix + 'Project/WorkDetail/:idx'
		,name: 'ProjectWorkDetail'
		,component: () => import('@/view/Project/ProjectWorkDetail')
	}
	,{
		path: prefix + 'Project/WorkView/:idx'
		,name: 'ProjectWorkView'
		,component: () => import('@/view/Project/ProjectWorkView')
	}
	,{
		path: prefix + 'Project/Task/:idx?'
		,name: 'ProjectTask'
		,component: () => import('@/view/Project/ProjectTask')
	}
	,{
		path: prefix + 'Project/TaskDetail/:idx'
		,name: 'ProjectTaskDetail'
		,component: () => import('@/view/Project/ProjectTaskDetail')
	}
	,{
		path: prefix + 'Project/TaskView/:idx'
		,name: 'ProjectTaskView'
		,component: () => import('@/view/Project/ProjectTaskView')
	}
	,{
		path: prefix + 'Project/Report/:idx'
		,name: 'ProjectReport'
		,component: () => import('@/view/Project/ProjectReport')
	}
	,{
		path: prefix + 'Project/ReportView/:idx'
		,name: 'ProjectReportView'
		,component: () => import('@/view/Project/ProjectReportView')
	}
	,{
		path: prefix + 'Project/ReportDetail/:idx'
		,name: 'ProjectReportDetail'
		,component: () => import('@/view/Project/ProjectReportDetail')
	}
	,{
		path: prefix + 'Member/List'
		,name: 'MemberList'
		,component: () => import('@/view/Member/MemberList')
	}
	,{
		path: prefix + 'Member/Item'
		,name: 'MemberItem'
		,component: () => import('@/view/Member/MemberItem')
	}
	,{
		path: prefix + 'Member/View/:idx'
		,name: 'MemberView'
		,component: () => import('@/view/Member/MemberView')
	}
	,{
		path: prefix + 'Member/Detail/:idx'
		,name: 'MemberDetail'
		,component: () => import('@/view/Member/MemberDetail')
	}
	,{
		path: '*',
		name:'404', 
		component: () => import('@/view/Error/NotFound.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	// console.log('from: ' + from.path + ' to : ' + to.path)
	next();
});

export default router
